<div [ngSwitch]="go" id="layout">
  <div *ngSwitchCase="'dashboard'" id="layout-page">
    <div id="layout-menu">
      <app-menu></app-menu>
    </div>

    <!-- <div id="layout-header" [ngStyle]="{'height': (isMmcUser ? '104px' : '64px')}"> -->
    <div id="layout-header" [ngClass]="isMmcUser ? 'header-height' : 'user-bar-height'">
      <app-header></app-header>
    </div>

    <div id="layout-content" [ngClass]="{'content-height-admin': isMmcUser, 'content-height-noadmin': !isMmcUser}">
      <!-- <div id="layout-content-inside" [ngClass]="{ 'min-height-100': this.path === '/dashboard' }"> -->
      <div id="layout-content-inside">
        <router-outlet></router-outlet>
      </div>
      <div id="layout-footer" [ngClass]="{ 'f-width': this.path === '/dashboard' }">
        <app-footer></app-footer>
      </div>
    </div>
  </div>

  <div *ngSwitchCase="'login'">
    <router-outlet></router-outlet>
  </div>

  <div *ngSwitchCase="'changepassword'">
    <router-outlet></router-outlet>
  </div>
</div>